import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TaskService } from '../../../../core/services/task.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { FilesService } from '../../../../core/services/files.service';
import { SETTINGS } from '../../../../core/configs/common.settings';
import { AppUtils } from '../../../../core/configs/app.utils';
import { ASSIGNABLE_STAFF_ROLES } from '../../../../core/configs/permissions.config';
import { ClientService } from '../../../../core/services/client.service';
import { UserService } from '../../../../core/services/user.service';
import { CompanyService } from '../../../../core/services/company.service';
import { ProjectService } from '../../../../core/services/project.service';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { GooglePlaceApiService } from '../../../../core/services/google-place-api.service';
import {
  getConvertedTimeOptions,
  isTimeExistAndGetValue,
} from '../../../../core/utli-functions/time';
import * as moment from 'moment/moment';
import { getMatchingContactsById } from "../../../../core/utli-functions/contacts";
import { Router } from '@angular/router';
import { PermissionService } from '../../../../core/services/permission.service';
import { PERMISSION } from '../../../../core/configs/permissions.config';
import { requiredMissing } from '../form-kit/required-missing';
import { TASK_TYPE_OPTIONS } from '../revamp/task-type.constants';

interface Options {
  name: string;
  value: string;
}

@Component({
  selector: 'app-add-edit-task-popup',
  templateUrl: './add-edit-task-popup.component.html',
  styleUrls: ['./add-edit-task-popup.component.scss'],
})
export class AddEditTaskPopupComponent implements OnInit {
  @Input() basicShow: boolean | undefined;
  @Input() editTaskId: string | undefined;
  @Input() clientID: string | undefined;
  @Input() companyID: string | undefined;
  @Input() layout: 'drawer' | 'page' = 'drawer';

  @Output() addTaskPopupOnChange: EventEmitter<any> = new EventEmitter();

  isDirty = false;
  buttonLoading = false;
  taskForm: FormGroup | any;
  formErrors: any;
  showPopup: boolean = false;

  taskNameValue: string = '';
  descriptionValue: string = '';
  startDateValue: Date | null = null;
  dueDateValue: Date | null = null;

  //attachment Add, Edit and Rename
  maxFileSize = 100000000;
  renameAttachmentForm: FormGroup | any;
  renameAttachmentFormErrors: any;
  renameAttachmentDialog = false;
  renameAttachmentIndex = 0;
  uploadedFiles: any[] = [];
  isFileUploading = false;
  baseAPI = SETTINGS.BASE_API;
  isFileUploaded = false;

  //Client select
  showCompanyField = true;
  isCompanyDisabled = false;
  companyNameOptions: any[] = [];
  company: any = null;
  selectedCompanyName = '';
  getClientsLoading = false;
  setProjectField = false;

  clientProjectsOption: any[] = [];
  clientsData: any[] = [];
  staff: Options[] = [];
  staffData: any[] = [];
  clients: any[] = [];
  BasicShow: boolean = false;
  isAddContact = true;
  noContacts = false;
  clientContacts: any[] = [];
  setContactPersonField = false;
  selectedClient: any;

  //project select
  isVisibleAddProject = false;
  projectForm: FormGroup | any;
  projectFormErrors: any;
  projectAddressFormErrors: any;

  selectedMapProjectLocation = '';
  projectAddressSelected = false;
  projectAddressMapLoading = false;
  dataFetchingToPopupAddress = false;
  updateProjectLoading = false;
  selectedClientProjects: any[] = [];
  labelStates: { [key: string]: boolean } = {};
  isStartTimeAdded = false;
  isEndTimeAdded = false;
  archived = false;
  matchedContacts = "";

  taskTypes = [...TASK_TYPE_OPTIONS];
  staffOptions: any[] = [];
  /** Populated staff from API while edit form loads; used to restore multiselect after options load. */
  private editAssignedStaff: any[] = [];
  reminderOptions = [
    { name: '15 Minutes', value: '15 Minutes' },
    { name: '30 Minutes', value: '30 Minutes' },
    { name: '1 Hour', value: '1 Hour' },
    { name: '2 Hours', value: '2 Hours' },
  ];
  statuses = [
    { name: 'Planning', value: 'PLANNING' },
    { name: 'In Progress', value: 'IN_PROGRESS' },
    { name: 'Hold', value: 'HOLD' },
    { name: 'Completed', value: 'COMPLETED' },
    { name: 'Cancelled', value: 'CANCELLED' },
    { name: 'Rejected', value: 'REJECTED' },
  ];

  statusSelectOptions = [
    { label: 'Planning', value: 'PLANNING', color: '#9C68D0' },
    { label: 'In Progress', value: 'IN_PROGRESS', color: '#EFB43D' },
    { label: 'Hold', value: 'HOLD', color: '#51ADCF' },
    { label: 'Completed', value: 'COMPLETED', color: '#90BD79' },
    { label: 'Cancelled', value: 'CANCELLED', color: '#E76E70' },
    { label: 'Rejected', value: 'REJECTED', color: '#778491' },
  ];
  clientPopupName = '';

  data: any[] = [];
  selectedClientName: any = {};
  isFetchingProjectData = false;
  dataLoading = false;

  timeOptions: any = getConvertedTimeOptions();

  statusOptions = [
    { label: 'Planning', value: 'PLANNING' },
    { label: 'In Progress', value: 'IN_PROGRESS' },
    { label: 'Hold', value: 'HOLD' },
    { label: 'Completed', value: 'COMPLETED' },
    { label: 'Cancelled', value: 'CANCELLED' },
    { label: 'Rejected', value: 'REJECTED' },
  ];

  //Add contact person references
  contactForm: FormGroup | any;
  isVisibleAddContact = false;
  contactFormErrors: any;
  updateContactLoading = false;

  constructor(
    private taskService: TaskService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private fb: FormBuilder,
    private fileService: FilesService,
    private clientService: ClientService,
    private companyService: CompanyService,
    private projectService: ProjectService,
    private placeApiService: GooglePlaceApiService,
    private cdr: ChangeDetectorRef,
    private userService: UserService,
    private router: Router,
    private permissionService: PermissionService,
  ) {
    this.contactFormErrors = {
      firstname: {},
      lastname: {},
      jobPosition: {},
      email: {},
      mobile: {},
      phoneNumber: {},
    };

  }

  ngOnInit() {
    // Permission guard: add task form (only TASK_ADD can add, TASK_EDIT_FULL can edit)
    if (this.editTaskId) {
      if (!this.permissionService.hasPermission(PERMISSION.TASK_EDIT_FULL)) {
        this.closeTaskForm();
        return;
      }
    } else {
      if (!this.permissionService.hasPermission(PERMISSION.TASK_ADD)) {
        this.closeTaskForm();
        return;
      }
    }

    this.dataLoading = true;
    this.initTaskForm();
    if (!this.editTaskId) {
      this.taskForm.patchValue({ startTime: '07:00', endTime: '15:00' });
      this.isStartTimeAdded = true;
      this.isEndTimeAdded = true;
    }
    this.initRenameAttachmentForm();
    this.handleFormDataPopulation();
    this.initProjectForm();
    this.initContactForm();

    this.taskNameValue = this.taskForm.get('title')?.value || '';
    this.descriptionValue = this.taskForm.get('description')?.value || '';
    this.startDateValue = this.taskForm.get('startDate')?.value || null;
    this.dueDateValue = this.taskForm.get('dueDate')?.value || null;

    this.taskForm.get('title')?.valueChanges.subscribe((value: string) => {
      this.taskNameValue = value;
    });

    this.taskForm
      .get('description')
      ?.valueChanges.subscribe((value: string) => {
        this.descriptionValue = value;
      });

    this.taskForm
      .get('startDate')
      ?.valueChanges.subscribe((value: Date | null) => {
        this.startDateValue = value;
      });

    this.taskForm
      .get('dueDate')
      ?.valueChanges.subscribe((value: Date | null) => {
        this.dueDateValue = value;
      });
  }

  loadStaffOptions(
    payload: any,
    currentStaff: any[] = [],
    onLoaded?: () => void
  ): void {
    const { role, ...rest } = payload || {};
    this.userService.getFilteredUsers(rest).subscribe(
      (res: any) => {
        const assignable = (res as any[]).filter(
          (u: any) => u?.role?.name && ASSIGNABLE_STAFF_ROLES.includes(u.role.name)
        );
        this.staffOptions = [];
        assignable.forEach((user: any) => {
          const value = String(user._id);
          if (!this.staffOptions.some((opt) => String(opt.value) === value)) {
            this.staffOptions.push({
              label: `${user?.firstname || ''} ${user?.lastname || ''}`.trim(),
              value,
            });
          }
        });
        const staffToMerge =
          currentStaff?.length > 0 ? currentStaff : this.editAssignedStaff;
        if (staffToMerge?.length) {
          this.mergeAssignedStaffIntoOptions(staffToMerge);
          if (this.editTaskId) {
            this.patchStaffControl(staffToMerge);
          }
        }
        onLoaded?.();
        this.cdr.markForCheck();
      },
      error => {
        console.error('Error loading staff members', error);
        onLoaded?.();
      }
    );
  }

  /** Normalize multiselect value to user id strings for API. */
  private mapStaffToIds(staff: unknown): string[] {
    if (staff == null) {
      return [];
    }
    const list = Array.isArray(staff) ? staff : [staff];
    return list
      .map((item: any) => {
        if (item == null) {
          return null;
        }
        if (typeof item === 'string') {
          return item;
        }
        if (typeof item === 'object') {
          if (item.value != null) {
            return String(item.value);
          }
          if (item._id != null) {
            return String(item._id);
          }
        }
        return String(item);
      })
      .filter((id): id is string => Boolean(id));
  }

  /** Keep already-assigned users in the dropdown even if not in the assignable filter. */
  private mergeAssignedStaffIntoOptions(staffMembers: any[]): void {
    (staffMembers || []).forEach((member: any) => {
      const id =
        member && typeof member === 'object' && member._id != null
          ? String(member._id)
          : String(member);
      if (!id || id === 'undefined') {
        return;
      }
      if (!this.staffOptions.some((opt) => String(opt.value) === id)) {
        const label =
          member && typeof member === 'object'
            ? `${member.firstname || ''} ${member.lastname || ''}`.trim() ||
              'Assigned user'
            : 'Assigned user';
        this.staffOptions.push({ label, value: id });
      }
    });
  }

  private patchStaffControl(staffMembers: any[]): void {
    const ids = this.mapStaffToIds(staffMembers);
    this.taskForm.get('staff')?.setValue(ids.length ? ids : null);
  }
  get title(): string {
    return this.editTaskId ? 'Edit task' : 'Add task';
  }

  get missingFields(): string[] {
    if (!this.taskForm || this.dataLoading) return [];
    return requiredMissing(this.taskForm, [
      { label: 'Title', control: 'title' },
      { label: 'Description', control: 'description' },
      { label: 'Task type', control: 'taskType' },
      { label: 'Start date', control: 'startDate' },
      { label: 'Due date', control: 'dueDate' },
      { label: 'Status', control: 'status' },
    ]);
  }

  get canSave(): boolean {
    return (
      !this.buttonLoading &&
      !this.isFileUploading &&
      this.taskForm?.valid &&
      this.missingFields.length === 0
    );
  }

  get canAddClient(): boolean {
    return (
      !!this.company &&
      !this.isCompanyDisabled &&
      this.permissionService.hasPermission(PERMISSION.CLIENT_ADD)
    );
  }

  save(): void {
    if (!this.canSave) {
      this.taskForm.markAllAsTouched();
      return;
    }
    if (this.editTaskId) this.updateTask();
    else this.createTask();
  }

  onCompanySelect(value: string | null): void {
    if (!value || value === this.company) return;
    this.companyOnChange(value);
  }

  private contactIds(list: any): string[] {
    return (Array.isArray(list) ? list : [])
      .map((c: any) => (typeof c === 'string' ? c : c?.value || c?._id))
      .filter(Boolean);
  }
  initProjectForm(): void {
    this.projectForm = this.fb.group({
      name: [null, [Validators.required]],
      address: this.fb.group({
        street: [null],
        suburb: [null],
        state: [null],
        postalCode: [
          null,
          [
            Validators.compose([
              Validators.required,
              Validators.pattern('^[0-9]+$'),
            ]),
          ],
        ],
        unit: [null],
      }),
    });

    this.projectForm.valueChanges.subscribe((form: any) => {
      this.projectFormErrors = AppUtils.getFormErrors(
        this.projectForm,
        this.projectFormErrors
      );
    });

    this.projectForm.get('address').valueChanges.subscribe((form: any) => {
      this.projectFormErrors = AppUtils.getFormErrors(
        this.projectForm,
        this.projectFormErrors
      );
    });
  }

  submitProjectData(): void {
    this.updateProjectLoading = true;
    const formData = this.projectForm.getRawValue();
    let payload: any;
    if (this.selectedClientProjects?.length > 0) {
      payload = {
        client: this.taskForm.get('client').value,
        ...formData,
      };
    } else {
      payload = {
        client: this.taskForm.get('client').value,
        ...formData,
        isFirst: true,
      };
    }
    this.projectService.createProject(payload).subscribe(
      res => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'New Project has been added!',
        });
        this.clientProjectSet(this.taskForm.get('client').value, res._id);
        this.projectForm.reset();
        this.isVisibleAddProject = false;
        this.updateProjectLoading = false;
        this.taskForm.get('projectName').patchValue(res._id);
        this.clientProjectsOption.push({
          label: res.name,
          value: res._id,
        });
      },
      () => {
        this.updateProjectLoading = false;
      }
    );
  }



  handleProjectAddressChange(address: Address): void {
    let address_components: any;
    address_components = address?.address_components;
    this.projectForm.get('address').reset();
    this.projectAddressMapLoading = false;

    address_components?.forEach((component: any) => {
      switch (component?.types[0]) {
        case 'unit':
          this.projectForm.patchValue({
            address: {
              unit: component?.long_name,
            },
          });
          break;
        case 'route':
          this.projectForm.patchValue({
            address: {
              street: component?.long_name,
            },
          });
          break;
        case 'locality':
          this.projectForm.patchValue({
            address: {
              suburb: component?.long_name,
            },
          });
          break;
        case 'administrative_area_level_1':
          this.projectForm.patchValue({
            address: {
              state: component?.long_name,
            },
          });
          break;
        case 'postal_code':
          this.projectForm.patchValue({
            address: {
              postalCode: component?.long_name,
            },
          });
          break;
      }
      this.placeApiService.placeFetchingInfo.next({
        type: 'popup',
        value: false,
      });
      this.selectedMapProjectLocation = '';
    });
  }
  handleSearchLocationDataChange(event: any): void {
    switch (event.name) {

      case 'popup-address':
        this.handleProjectAddressChange(event?.value);
        break;
    }
  }
  closeAddProject(): void {
    this.projectForm.reset();
    this.isVisibleAddProject = false;
  }
  visibleProjectForm(): void {
    if (this.setProjectField) {
      this.isVisibleAddProject = true;
    }
  }
  showDialog(name = '') {
    this.clientPopupName = name;
    this.BasicShow = true;
  }
  onAddClientPopupChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.BasicShow = event.value;
        break;
      case 'resp':
        if (this.company !== event.value.company) {
          this.company = event.value.company;
          const com = this.companyNameOptions.find(
            co => co.value === this.company
          );
          this.selectedCompanyName = com?.label;
        }
        this.getClients(true, event.value._id);
        this.BasicShow = false;
        break;
    }
  }

  getClients(isClientPop: boolean, clientID: string): void {
    if (!this.company) {
      this.getClientsLoading = false;
      this.taskForm.controls['client'].enable();
      return;
    }
    this.getClientsLoading = true;
    this.taskForm.controls['client'].disable();
    this.clientService.getAllClients({ company: this.company }).subscribe(
      (res: any) => {
        this.clients = [];
        this.clientsData = res as any;
        const clients = res as any;
        clients.map((cl: any) => {
          this.clients.push({
            label:
              cl?.type === 'PERSONAL'
                ? `${cl.firstname} ${cl.lastname}`
                : cl?.companyName,
            value: cl._id,
          });
        });

        isClientPop ? this.populateSelectedClient(clientID) : '';
        this.getClientsLoading = false;
      },
      () => {
        this.getClientsLoading = false;
        this.taskForm.controls['client'].enable();
      }
    );
  }

  populateSelectedClient(client: any): void {
    if (this.editTaskId) {
      this.taskForm.patchValue({ client: client });
      this.getClientsLoading = false;
      this.taskForm.controls['client'].enable();
    } else {
      this.taskForm.patchValue({ client: client });
      this.getClientsLoading = false;
      this.taskForm.controls['client'].enable();
    }
  }


  handleFormDataPopulation(): void {
    this.dataLoading = true;
    // this.isCompanyDisabled = true;
    this.setProjectField = false;
    this.showCompanyField = true;
    // this.taskForm.controls['client'].disable();
    // this.taskForm.controls['projectName'].disable();
    this.companyNameOptions = [];
    this.companyService.getAllCompanies().subscribe(
      (res: any) => {
        const companies = res as any;
        companies.map((com: any) => {
          this.companyNameOptions.push({ label: com.name, value: com._id });
        });

        if (this.editTaskId) {
          // when both values coming from client single view tasks
          if (this.clientID && this.companyID) {
            this.isCompanyDisabled = true;
            this.taskForm.get('client').disable();
          }
          this.setTaskValue();
        } else if (
          this.clientID !== undefined &&
          this.companyID !== undefined
        ) {
          this.company = this.companyID;

          this.loadStaffOptions({
            role: '64710bb740de86be5e1135c6',
            active: true,
            company: this.company,
            archived: false
          })

          this.clientService
            .getAllClients({ company: this.companyID })
            .subscribe(
              res => {
                this.clientsData = res as any;
                const clients = res as any;
                clients.map((cl: any) => {
                  this.clients.push({
                    label:
                      cl?.type === 'PERSONAL'
                        ? `${cl.firstname} ${cl.lastname}`
                        : cl?.companyName,
                    value: cl._id,
                  });
                });
                this.getClientsLoading = false;
                this.taskForm.controls['client'].disable();
                this.dataLoading = false;
              },
              () => {
                this.getClientsLoading = false;
                this.dataLoading = false;
                this.taskForm.controls['client'].enable();
              }
            );

          this.taskForm.get('client').markAsDirty(true);
          this.taskForm.patchValue({ client: this.clientID });
          this.taskForm.markAsPristine();
        } else if (localStorage.getItem(SETTINGS.COMPANY)) {
          this.getClientsLoading = true;
          this.clients = [];
          this.company = localStorage.getItem(SETTINGS.COMPANY);
          this.showCompanyField = false;
          const com = this.companyNameOptions.find(
            co => co.value === this.company
          );
          this.selectedCompanyName = com?.label;
          this.loadStaffOptions({
            role: '64710bb740de86be5e1135c6',
            active: true,
            company: this.company,
            archived: false
          })
          this.clientService.getAllClients({ company: this.company }).subscribe(
            res => {
              this.clientsData = res as any;
              const clients = res as any;
              clients.map((cl: any) => {
                this.clients.push({
                  label:
                    cl?.type === 'PERSONAL'
                      ? `${cl.firstname} ${cl.lastname}`
                      : cl?.companyName,
                  value: cl._id,
                });
              });
              this.getClientsLoading = false;
              this.taskForm.controls['client'].enable();
              this.dataLoading = false;
            },
            () => {
              this.getClientsLoading = false;
              this.dataLoading = false;
              this.taskForm.controls['client'].enable();
            }
          );
        } else {
          this.isCompanyDisabled = false;
          this.dataLoading = false;
        }
      },
      (error: any) => {
        this.endTaskEditLoading();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${error?.error?.message ? error?.error?.message : 'Error'}`,
        });
      }
    );
  }
  companyOnChange(value: string): void {
    this.company = value;
    if (this.companyNameOptions.length > 0) {
      const com = this.companyNameOptions?.find(co => co.value === value);
      this.selectedCompanyName = com?.label;
    }
    this.getClientsLoading = true;
    this.setProjectField = false;
    this.taskForm.get('client').reset();
    this.taskForm.get('client').disable();
    this.clients = [];
    this.staffOptions = [];
    this.taskForm.get('projectName').reset();
    this.taskForm.get('projectName').disable();
    this.clientProjectsOption = [];

    this.loadStaffOptions({
      role: '64710bb740de86be5e1135c6',
      active: true,
      company: this.company,
      archived: false
    });

    this.clientService.getAllClients({ company: this.company }).subscribe(
      res => {
        this.getClientsLoading = false;
        this.taskForm.controls['client'].enable();
        this.clientsData = res as any;
        const clients = res as any;
        clients.map((cl: any) => {
          this.clients.push({
            label:
              cl?.type === 'PERSONAL'
                ? `${cl.firstname} ${cl.lastname}`
                : cl?.companyName,
            value: cl._id,
          });
        });
      },
      () => {
        this.getClientsLoading = false;
        this.taskForm.controls['client'].enable();
      }
    );
  }
  onAttachmentUpload(event: any, uploader: { clear: () => void }): void {
    this.onUpload(event);
    uploader.clear();
  }
  onUpload(event: any) {
    for (const file of event.files) {
      this.isFileUploading = true;
      this.fileService.postFile(file).subscribe(
        res => {
          this.uploadedFiles.push({
            originalFileName: file.name,
            url: res.url,
          });
          // this.isFileUploaded = true; // Set the flag to true when a file is uploaded

          if (this.editTaskId) {
            this.taskService
              .updateTask({
                _id: this.editTaskId,
                attachments: this.uploadedFiles,
              })
              .subscribe();
          } else {
            this.isDirty = false;
          }
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Attachments have been added!',
          });
          this.isFileUploading = false;
        },
        (error: any) => {
          this.isFileUploading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${error?.error?.message ? error?.error?.message : 'Error'
              }`,
          });
        }
      );
    }
  }
  removeFile(event: Event, index: number): void {
    this.confirmationService.confirm({
      key: 'removeFile',
      message: `Are you sure you want to delete this attachment?`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.uploadedFiles.splice(index, 1);
        // this.isFileUploaded = this.uploadedFiles.length > 0; // Update the flag based on the file count

        if (this.editTaskId) {
          this.taskService
            .updateTask({
              _id: this.editTaskId,
              attachments: this.uploadedFiles,
            })
            .subscribe();
        } else {
          this.isDirty = false;
        }
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Attachment has been deleted!',
        });
      },
      reject: () => { },
    });
  }

  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else {
      for (let i = 0; i < control.value.length; i++) {
        const letter = control.value[i];
        if (letter === '.' || letter === '/') {
          return { confirm: true, error: true };
        }
      }
    }
    return {};
  };
  initRenameAttachmentForm() {
    this.renameAttachmentForm = this.fb.group({
      fileName: [
        '',
        Validators.compose([Validators.required, this.confirmationValidator]),
      ],
      fileExtension: [{ value: '', disabled: true }, Validators.required],
    });
    this.renameAttachmentForm.valueChanges.subscribe(() => {
      this.renameAttachmentFormErrors = AppUtils.getFormErrors(
        this.renameAttachmentForm,
        this.renameAttachmentFormErrors
      );
    });
  }
  renameAttachmentSave() {
    const editedFileName = this.renameAttachmentForm.getRawValue();
    this.uploadedFiles[this.renameAttachmentIndex].originalFileName =
      editedFileName.fileName + '.' + editedFileName.fileExtension;
    if (this.editTaskId) {
      this.taskService
        .updateTask({
          _id: this.editTaskId,
          attachments: this.uploadedFiles,
        })
        .subscribe();
    } else {
      this.isDirty = false;
    }
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Attachment has been renamed!',
    });
    this.renameAttachmentDialog = false;
  }

  renameAttachmentCancel() {
    this.renameAttachmentDialog = false;
  }
  renameAttachment(index: any) {
    this.renameAttachmentIndex = index;
    const selectedFileName = this.uploadedFiles[index].originalFileName;
    const fileNameParts = selectedFileName.split('.');
    this.renameAttachmentForm.patchValue({
      fileName: fileNameParts[0],
      fileExtension: fileNameParts[fileNameParts.length - 1],
    });
    this.renameAttachmentDialog = true;
  }
  getIcon(file: string): string {
    return AppUtils.getUrlExtension(file);
  }
  private endTaskEditLoading(): void {
    this.dataLoading = false;
    this.cdr.markForCheck();
  }

  /** API expects company as string id; task payload may send ObjectId or populated doc. */
  private normalizeCompanyId(company: unknown): string | null {
    if (company == null || company === '') {
      return null;
    }
    if (typeof company === 'object' && company !== null && '_id' in (company as object)) {
      return String((company as { _id: unknown })._id);
    }
    return String(company);
  }

  private getClientIdForProjects(res: any): string | null {
    const c = res?.client;
    if (c == null) {
      return null;
    }
    if (typeof c === 'object' && c._id != null) {
      return String(c._id);
    }
    return String(c);
  }

  /** Populate form after task + clients are loaded (projects may be empty if project request failed). */
  private applyTaskEditPayload(res: any): void {
    const companyId = this.normalizeCompanyId(res?.company);
    if (companyId) {
      this.company = companyId;
    }
    const mappedContacts = this.contactIds(res?.contactPerson);
    this.editAssignedStaff = res?.staff || [];
    this.mergeAssignedStaffIntoOptions(this.editAssignedStaff);
    this.taskForm.patchValue({
      ...res,
      client: res?.client?._id,
      contactPerson: mappedContacts,
      staff: this.mapStaffToIds(this.editAssignedStaff),
    });
    this.selectedClient = this.clientsData.find(
      (cl: any) => cl._id === res?.client?._id
    );
    this.taskForm.get('startDate')?.patchValue(new Date(res.startDate));
    this.taskForm.get('dueDate')?.patchValue(new Date(res.dueDate));
    if (res.isStartTimeAdded) {
      this.taskForm
        .get('startTime')
        ?.patchValue(moment(res.startDate).format('HH:mm'));
      this.isStartTimeAdded = true;
    }
    if (res.isEndTimeAdded) {
      this.taskForm
        .get('endTime')
        ?.patchValue(moment(res.dueDate).format('HH:mm'));
      this.isEndTimeAdded = true;
    }
    if (res?.client?.contacts?.length) {
      this.clientContacts = [];
      res.client?.contacts.forEach((co: any) => {
        this.clientContacts.push({
          label: `${co.firstname} ${co.lastname}`,
          value: co._id,
        });
      });
    }
    this.noContacts = !res?.client?.contacts?.length;
    this.setContactPersonField = true;
    this.uploadedFiles = res.attachments || [];
  }

  setTaskValue() {
    this.dataLoading = true;
    this.taskService.getOneTaskId(this.editTaskId).subscribe({
      next: (res: any) => {
        const companyId = this.normalizeCompanyId(res?.company);
        if (companyId) {
          this.company = companyId;
        }

        this.staffOptions = [];
        this.editAssignedStaff = res?.staff || [];
        this.loadStaffOptions({
          role: '64710bb740de86be5e1135c6',
          active: true,
          company: companyId || undefined,
          archived: false,
        }, res?.staff);

        // Show current client immediately; full list loads in background (same as after company select).
        this.clients = [];
        this.clientsData = [];
        const embedded = res?.client;
        if (embedded && typeof embedded === 'object' && embedded._id) {
          this.clientsData = [embedded];
          this.clients.push({
            label:
              embedded?.type === 'PERSONAL'
                ? `${embedded.firstname} ${embedded.lastname}`
                : embedded?.companyName,
            value: embedded._id,
          });
        }

        if (companyId) {
          this.clientService.getAllClients({ company: companyId }).subscribe({
            next: (cli) => {
              this.clientsData = cli as any;
              this.clients = [];
              (cli as any[]).forEach((cl: any) => {
                this.clients.push({
                  label:
                    cl?.type === 'PERSONAL'
                      ? `${cl.firstname} ${cl.lastname}`
                      : cl?.companyName,
                  value: cl._id,
                });
              });
              this.cdr.markForCheck();
            },
            error: () => {
              /* Keep seeded client row; user can change company to retry loading the full list. */
            },
          });
        }

        this.clientProjectsOption = [];
        const projectClientId = this.getClientIdForProjects(res);
        if (!projectClientId) {
          this.applyTaskEditPayload(res);
          this.endTaskEditLoading();
          return;
        }

        this.projectService.getProjectsByClient(projectClientId).subscribe({
          next: (project: any) => {
            if (project?.length > 0) {
              project.forEach((pro: any) => {
                this.clientProjectsOption.push({
                  label: pro.name,
                  value: pro._id,
                });
              });
            }
            this.applyTaskEditPayload(res);
            this.endTaskEditLoading();
          },
          error: () => {
            this.messageService.add({
              severity: 'warn',
              summary: 'Projects',
              detail: 'Could not load projects; you can still edit this task.',
            });
            this.applyTaskEditPayload(res);
            this.endTaskEditLoading();
          },
        });
      },
      error: (error: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${error?.error?.message ?? 'Could not load task.'}`,
        });
        this.endTaskEditLoading();
      },
    });
  }
  closeTaskForm(): void {
    this.addTaskPopupOnChange.emit({ name: 'isVisible', value: false });
    this.basicShow = false;
    this.editTaskId = '';
    this.editAssignedStaff = [];
    this.staffOptions = [];
  }

  dialogClose() {
    if (this.isDirty || this.taskForm?.dirty) {
      this.confirmationService.confirm({
        key: 'canDeactivateConfirmDialog',
        message: `Are you sure you want to discard all unsaved changes?`,
        icon: 'pi pi-exclamation-triangle',
        header: 'Discard Changes?',
        acceptLabel: 'Discard Changes',
        acceptIcon: 'pi pi-times',
        accept: () => {
          this.closeTaskForm();
        },
        rejectLabel: 'Keep Editing',
        rejectIcon: 'pi pi-check',
        reject: () => { },
      });
    } else {
      this.closeTaskForm();
    }
  }

  initTaskForm(): void {
    this.taskForm = this.fb.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      staff: [null],
      contactPerson: [],
      startDate: [null, Validators.required],
      dueDate: [null, Validators.required],
      startTime: [],
      endTime: [],
      client: [null],
      taskType: [null, Validators.required],
      projectName: [null],
      reminder: [null],
      status: ['PLANNING', Validators.required],
    });

    this.taskForm.get('staff').valueChanges.subscribe((val: any) => {
    });

    this.taskForm.get('client').valueChanges.subscribe((val: any) => {
      if (this.taskForm.get('client').dirty) {
        this.setProjectField = false;
        this.clientProjectSet(val);
      }
      this.selectedClientName = this.clients.find(cl => cl.value === val);
    });

    this.taskForm.get('startTime').valueChanges.subscribe((val: any) => {
      if (this.taskForm.get('startTime')?.dirty) {
        this.isStartTimeAdded = true;
      }
    });

    this.taskForm.get('endTime').valueChanges.subscribe((val: any) => {
      if (this.taskForm.get('endTime')?.dirty) {
        this.isEndTimeAdded = true;
      }
    });

    this.taskForm.get('client').valueChanges.subscribe((val: any) => {
      if (
        this.taskForm.get('client').dirty ||
        (this.companyID && this.clientID)
      ) {
        this.setProjectField = false;
        this.clientProjectSet(val);
      }
      this.selectedClient = this.clientsData.find(cl => cl._id === val);

      this.selectedClientName = this.clients.find(cl => cl.value === val);

      this.setContactPersonField = true;
      if (this.selectedClient?.contacts?.length) {
        this.clientContacts = [];
        this.selectedClient.contacts.map((co: any) => {
          this.clientContacts.push({
            label: `${co.firstname} ${co.lastname}`,
            value: co._id,
          });
        });
        this.noContacts = false;
      } else {
        this.noContacts = true;
      }
    })

  }

  setDefaultTime(hours: number): Date {
    const time = new Date();
    time.setHours(hours);
    time.setMinutes(0);
    time.setSeconds(0);
    return time;
  }

  clientProjectSet(cliId: any, proId?: string, iniInit?: boolean): void {
    this.isFetchingProjectData = true;
    this.clientProjectsOption = [];
    this.taskForm.controls['projectName'].disable();
    this.projectService.getProjectsByClient(cliId).subscribe(
      (res: any) => {
        if (res?.length > 0) {
          res?.map((pro: any) => {
            this.clientProjectsOption.push({
              label: pro.name,
              value: pro._id,
            });
          });
        }
        this.taskForm.controls['projectName'].enable();
        this.isFetchingProjectData = false;
        this.setProjectField = true;
      },
      (e: any) => {
        this.isFetchingProjectData = false;
        this.setProjectField = true;
      }
    );
  }
  updateTask(): void {
    const formData = this.taskForm.getRawValue();
    const contacts = this.selectedClient?.contacts || [];
    const matchedContacts = getMatchingContactsById(
      this.contactIds(formData.contactPerson).map(id => ({ value: id })),
      contacts
    );
    formData._id = this.editTaskId;
    formData.company = this.company;
    formData.staff = this.mapStaffToIds(formData.staff);
    formData.startTime = isTimeExistAndGetValue(formData.startTime);
    formData.endTime = isTimeExistAndGetValue(formData.endTime);
    formData.startDate = moment(formData.startDate)
      .set({
        hour: moment(formData.startTime, 'hh:mm').hours(),
        minute: moment(formData.startTime, 'hh:mm').minutes(),
        second: moment(formData.startTime, 'hh:mm').seconds(),
      })
      .toDate();
    formData.dueDate = moment(formData.dueDate)
      .set({
        hour: moment(formData.endTime, 'hh:mm').hours(),
        minute: moment(formData.endTime, 'hh:mm').minutes(),
        second: moment(formData.endTime, 'hh:mm').seconds(),
      })
      .toDate();

    this.buttonLoading = true;
    this.taskService.updateTask({
      ...formData, contactPerson: matchedContacts,
      isStartTimeAdded: this.isStartTimeAdded,
      isEndTimeAdded: this.isEndTimeAdded
    }).subscribe(
      () => {
        this.taskForm.reset();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Updated Successfully',
        });
        this.buttonLoading = false;
        this.closeTaskForm();
      },
      e => {
        this.buttonLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to Update Task',
        });
      }
    );
  }

  createTask(): void {
    const formData = this.taskForm.getRawValue();

    if (formData.contactPerson) {
      this.matchedContacts = getMatchingContactsById(
        this.contactIds(formData.contactPerson).map(id => ({ value: id })),
        this.selectedClient?.contacts || []
      );
    }

    formData.startTime = isTimeExistAndGetValue(formData.startTime);
    formData.endTime = isTimeExistAndGetValue(formData.endTime);
    formData.startDate = moment(formData.startDate)
      .set({
        hour: moment(formData.startTime, 'hh:mm').hours(),
        minute: moment(formData.startTime, 'hh:mm').minutes(),
        second: moment(formData.startTime, 'hh:mm').seconds(),
      })
      .toDate();
    formData.dueDate = moment(formData.dueDate)
      .set({
        hour: moment(formData.endTime, 'hh:mm').hours(),
        minute: moment(formData.endTime, 'hh:mm').minutes(),
        second: moment(formData.endTime, 'hh:mm').seconds(),
      })
      .toDate();

    formData.company = this.company;
    formData.staff = this.mapStaffToIds(formData.staff);
    this.buttonLoading = true;

    this.taskService
      .createTask({
        ...formData, contactPerson: this.matchedContacts, attachments: this.uploadedFiles,
        isStartTimeAdded: this.isStartTimeAdded,
        isEndTimeAdded: this.isEndTimeAdded
      })
      .subscribe(
        () => {
          this.taskForm.reset();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Task Created Successfully',
          });
          this.buttonLoading = false;
          this.closeTaskForm();
        },
        e => {
          this.buttonLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to Create Task',
          });
        }
      );
  }

  visibleContactForm(): void {
    this.isVisibleAddContact = true;
  }


  initContactForm(): void {
    this.contactForm = this.fb.group({
      firstname: [null, [Validators.required]],
      lastname: [null, [Validators.required]],
      jobPosition: [null],
      email: [null, [Validators.required, Validators.email]],
      mobile: [
        null,
        [
          Validators.compose([
            Validators.required,
            Validators.pattern(SETTINGS.REGEX.COUNTRY_CODE_PHONE.EXP),
          ]),
        ],
      ],
      phoneNumber: [
        null,
        [
          Validators.compose([
            Validators.pattern(SETTINGS.REGEX.COUNTRY_CODE_PHONE.EXP),
          ]),
        ],
      ],
    });

    this.contactForm.valueChanges.subscribe((form: any) => {
      this.contactFormErrors = AppUtils.getFormErrors(
        this.contactForm,
        this.contactFormErrors
      );
    });
  }

  submitContactData(): void {
    this.updateContactLoading = true;
    const contact = this.contactForm.getRawValue();
    this.selectedClient.contacts.push(contact);
    const currentContact: string[] = this.contactIds(
      this.taskForm.get('contactPerson').value
    );
    this.clientService
      .updateClient({
        _id: this.selectedClient._id,
        contacts: this.selectedClient?.contacts,
      })
      .subscribe(
        (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'New contact person has been added!',
          });
          this.updateContactLoading = false;
          this.clientContacts = [];
          this.selectedClient.contacts = res.contacts;
          res.contacts.map((co: any) => {
            this.clientContacts.push({
              label: `${co.firstname} ${co.lastname}`,
              value: co._id,
            });
          });

          const lastElement =
            this.clientContacts[this.clientContacts.length - 1];
          if (lastElement) currentContact.push(lastElement.value);
          this.taskForm.patchValue({ contactPerson: currentContact });

          this.noContacts = false;
          this.isVisibleAddContact = false;
          this.contactForm.reset();
        },
        (error: any) => {
          this.updateContactLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${error?.error?.message ? error?.error?.message : 'Error'
              }`,
          });
        }
      );
  }
}
